export default __webpack_public_path__ + "static/sfx-bg_2-b0ff42d370872fd6d53bda82704d46a2.png";